<div class="flex gap-x-15px items-center">
    <button
        class="button-white-chevron"
        (click)="prevItem()"
        aria-label="Next slide"
        [disabled]="currentItemIndex() === 0"
    >
        <companyid-chevron position="left" color="gray" smallSize />
    </button>
    <button
        class="button-white-chevron"
        (click)="nextItem()"
        aria-label="Previous slide"
        [disabled]="currentItemIndex() + 1 === contentItemsLength()"
    >
        <companyid-chevron position="right" color="gray" smallSize />
    </button>
</div>
<div
    class="flex bg-white rounded-6px border border-solid border-stroke items-center text-medium-medium text-dark-7 px-15px h-9"
>
    <span class="text-primary-text-color">{{ currentItemIndex() + 1 }}</span
    >/{{ contentItemsLength() }}
</div>
